<section #customSmartActionBtn *ngIf="this.wrapperTemplate; else defaultTemplate"
    (click)="this.takeAction($event, customContextMenu)">
    <ng-container [ngTemplateOutlet]="this.wrapperTemplate">
    </ng-container>

    <p-contextMenu #customContextMenu appendTo="body" [target]="customSmartActionBtn"
        [style]="{'white-space':'nowrap', 'width': 'auto'}" [model]="menuItems">
    </p-contextMenu>
</section>

<ng-template #defaultTemplate>
    <ng-container [ngSwitch]="true">

        <ng-template [ngSwitchCase]="disabled">
            <ng-container [ngSwitch]="this.displayMode">
                <ng-template [ngSwitchCase]="'button'">
                    <button pButton pRipple class="no-wrap smart-action-btn" [disabled]="true"
                        [ngClass]="this.buttonClass" [icon]="icon" [label]="label" pTooltip="Not action"
                        tooltipPosition="top">
                    </button>
                </ng-template>

                <ng-template [ngSwitchCase]="'standalone'">
                    <ng-container *ngFor="let actionItem of menuItems">
                        <ng-container *ngIf="actionItem.sourceAction">
                            <ng-container
                                *ngTemplateOutlet="actionItem.sourceAction.template ? actionItem.sourceAction.template : disabledSplittedItemTemplate; context: {$implicit: actionItem, disabled: this.disabled}">
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </ng-template>
            </ng-container>
        </ng-template>

        <ng-template ngSwitchDefault>
            <ng-container [ngSwitch]="this.displayMode">
                <ng-template [ngSwitchCase]="'button'">
                    <button #smartActionsBtn pButton pRipple class="no-wrap smart-action-btn"
                        [ngClass]="this.buttonClass" [disabled]="disabled"
                        (click)="this.takeAction($event, contextMenu)"
                        [icon]="context?.activeActions?.length !== 1 ? undefined : context?.activeActions[0].icon"
                        [label]="label"
                        [pTooltip]="context?.activeActions?.length == 0 ? '' : (context?.activeActions?.length === 1 ? context?.activeActions[0].description : 'Multiple Actions')"
                        tooltipPosition="top"></button>
                </ng-template>

                <ng-template [ngSwitchCase]="'standalone'">
                    <ng-container *ngFor="let actionItem of menuItems">
                        <ng-container *ngIf="actionItem.sourceAction">
                            <ng-container
                                *ngTemplateOutlet="actionItem.sourceAction.template ? actionItem.sourceAction.template : defaultSplittedItemTemplate; context: {$implicit: actionItem}">
                            </ng-container>
                        </ng-container>

                    </ng-container>
                </ng-template>
            </ng-container>
        </ng-template>
    </ng-container>

    <ng-template #disabledSplittedItemTemplate let-actionItem>
        <button pButton pRipple class="tw-mr-2 p-button-rounded" [disabled]="true"
            (click)="this.standaloneActionClick($event, actionItem)" [icon]="actionItem.icon"
            [pTooltip]="actionItem.displayName" tooltipPosition="top">
        </button>
    </ng-template>

    <ng-template #defaultSplittedItemTemplate let-actionItem>
        <button pButton pRipple class="tw-mr-2 p-button-rounded" [disabled]="this.disabled"
            (click)="this.standaloneActionClick($event, actionItem)" [icon]="actionItem.icon"
            [pTooltip]="actionItem.displayName" tooltipPosition="top">
        </button>
    </ng-template>
</ng-template>

<p-contextMenu #contextMenu appendTo="body" [target]="smartActionsBtn"
    [style]="{'white-space':'nowrap', 'width': 'auto'}" [model]="menuItems" [autoZIndex]="this.zIndex != null"
    [baseZIndex]="this.zIndex || 99999">
</p-contextMenu>

<p-confirmDialog [key]="'confirmDialog' + (key || '')" appendTo="body"
    rejectButtonStyleClass="p-button-warning p-button-outlined">
</p-confirmDialog>
<p-confirmDialog [key]="'confirmPopup' + (key || '')" appendTo="body"
    rejectButtonStyleClass="p-button-warning p-button-outlined">
</p-confirmDialog>

<ng-container *ngIf="this.executeActions && this.lazyComponentHandler?.customViewSync">
    <ng-template [appLazy]="this.lazyComponentHandler?.customViewSync"
        [appLazyData]="this.lazyComponentHandler?.currentCustomViewMetadata">
    </ng-template>
</ng-container>
